export default __webpack_public_path__ + "static/lucas-d8b78558cc95f0cfc091dfd5cb6c169d.webp";